import React from 'react'

import { useAppSelector } from '../../store/hooks'
import { selectAuthUserSlice } from '../../store/auth-user-slice'
import { selectAuthCompanySlice } from '../../store/auth-company-slice'
import { PopupNewsModal } from '../../components/popup-news-modal'
import { OnboardingADP, OnboardingADPConnector } from '../../components/adp/onboarding-adp'
import PlanBoostEndingModal from '../../components/plan-boost-ending-modal'
import { useWhatsNewPopup } from './useWhatsNewPopup'

const MainAppCompanions = (): React.ReactElement => {
  const { authUser } = useAppSelector(selectAuthUserSlice)
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  const { showPopupNewsModal, showPopupNews, closePopup, closePopupWithoutHint } = useWhatsNewPopup()

  const adpOnboarding = authCompany?.integrationOnboardings?.find((onboarding) => onboarding.name === 'ADP')
  const adpConnectorOnboarding = authCompany?.integrationOnboardings?.find((onboarding) => onboarding.name === 'ADP-CONNECTOR')

  return (
    <>
      <OnboardingADP
        visible={authUser.role === 'Admin' && Boolean(adpOnboarding) && Number(adpOnboarding?.completedPercentage) < 100}
        completedPercentage={adpOnboarding?.completedPercentage || 0}
      />
      <OnboardingADPConnector
        visible={authUser.role === 'Admin' && Boolean(adpConnectorOnboarding) && Number(adpConnectorOnboarding?.completedPercentage) < 100}
        completedPercentage={adpConnectorOnboarding?.completedPercentage || 0}
      />
      <PlanBoostEndingModal />
      <PopupNewsModal showPopupNewsModal={showPopupNewsModal} news={showPopupNews} onCancel={closePopup} onOpenNews={closePopupWithoutHint} />
    </>
  )
}

export default MainAppCompanions
